enum ContactInfoTypes {
  home = 'home',
  mobile = 'mobile',
  work = 'work',
  temporary = 'temporary',
  old = 'old',
}

export default ContactInfoTypes
